module.exports = __webpack_public_path__ + "img/18.29ed6d0e.png";